import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import de from 'dayjs/locale/de';
import { twoDigitDateParseFunction } from './two-digit-date-parser';
import minMax from 'dayjs/plugin/minMax';
import dayOfYear from 'dayjs/plugin/dayOfYear';

//only for type recognition in build
import 'dayjs/plugin/customParseFormat';
import 'dayjs/plugin/isSameOrAfter';
import 'dayjs/plugin/isSameOrBefore';
import 'dayjs/plugin/minMax';
import 'dayjs/plugin/dayOfYear';

dayjs.extend(customParseFormat, {
  parseTwoDigitYear: twoDigitDateParseFunction,
});
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(minMax);
dayjs.extend(dayOfYear);
dayjs.locale(de);

export { dayjs };
